export default __webpack_public_path__ + "static/media/docker-original.0427327a.svg";